import { z } from 'zod';
import { reactionProductSchema } from '@/models/reactionProductSchema';
import { lineSchema } from './lineSchema';
import { operatorSchema } from './operatorSchema';
import { annotationSchema } from './annotationSchema';

export const publicationElementSchema = z.object({
  elementId: z.string(),
  id: z.union([z.number().int().positive(), z.string()]),
  reactionId: z.string().optional(),
  kinetics: z.record(z.unknown()).nullable().optional(),
  line: lineSchema.optional(),
  map: z.number(),
  modifiers: z.array(reactionProductSchema).optional(),
  name: z.string(),
  notes: z.string(),
  operators: z.array(operatorSchema).optional(),
  processCoordinates: z.null().optional(),
  products: z.array(reactionProductSchema).optional(),
  reactants: z.array(reactionProductSchema).optional(),
  references: z.array(annotationSchema),
  reversible: z.boolean().optional(),
  sboTerm: z.string(),
  symbol: z.string().nullable().optional(),
  synonyms: z.array(z.string()).optional(),
  visibilityLevel: z.string(),
  z: z.number(),
});
